import { render, staticRenderFns } from "./pays.vue?vue&type=template&id=3fcd10b4"
import script from "./pays.vue?vue&type=script&lang=js"
export * from "./pays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports